import React, { useState, useEffect } from 'react';
import { calculateLevelProgress } from '../utils/xpLevelUtils';
import './AchievementsCompact.css';

function AchievementsCompact({ userId, isOwnProfile = false, xp = 0, level = 1 }) {
  const [levelProgress, setLevelProgress] = useState(null);

  useEffect(() => {
    const loadProgress = async () => {
      const progress = await calculateLevelProgress(xp, level);
      setLevelProgress(progress);
    };
    
    if (xp !== undefined && level !== undefined) {
      loadProgress();
    }
  }, [xp, level]);


  // Get display values
  const currentLevel = levelProgress?.currentLevel || level || 1;
  const getXPText = () => {
    if (levelProgress?.nextLevel) {
      return `${xp} / ${levelProgress.nextLevelXP} XP`;
    } else {
      return `${xp} XP`;
    }
  };


  return (
    <div className="achievements-compact">
      <span className="achievements-compact-level-pill">
        Level {currentLevel}
      </span>
      <span className="achievements-compact-text">
        {' '}({getXPText()})
      </span>
    </div>
  );
}

export default AchievementsCompact;

